import { render, staticRenderFns } from "./DataTableMenu.vue?vue&type=template&id=48ebfbf8&lang=pug"
import script from "./DataTableMenu.vue?vue&type=script&lang=js"
export * from "./DataTableMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports